module.exports = __webpack_public_path__ + "static/media/icon-filter-black.ddc9cdb2.svg";